import { render, staticRenderFns } from "./calendarSwitch.vue?vue&type=template&id=0fb6be15&"
import script from "./calendarSwitch.vue?vue&type=script&lang=js&"
export * from "./calendarSwitch.vue?vue&type=script&lang=js&"
import style0 from "./calendarSwitch.vue?vue&type=style&index=0&id=0fb6be15&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports